import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CityLicenseManagementComponent } from './pages/city-license-management/city-license-management.component';
import { LicenseManagementComponent } from './pages/license-management/license-management.component';

const routes: Routes = [

  {
    path: 'city-management',
    component: CityLicenseManagementComponent,
    data: {
      title: 'admin.configuration.map-license.title'
    },
  },
  {
    path: 'license-management',
    component: LicenseManagementComponent,
    data: {
      title: 'admin.configuration.map-license.license'
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicenseConfigurationRoutingModule { }
